// extracted by mini-css-extract-plugin
module.exports = {"pointTabs":"PointLevelHeaderTabs_pointTabs__q6Sq5"};